module.exports = __webpack_public_path__ + "static/york_laptop_old-1545e5fb20ad3978ae1583285565468b.png";